import { DriverNotebook, driverNotebooksT } from "dora-contracts";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api, { createDecoder } from "../../api";

type State = {
  entities: DriverNotebook[];
};

const initialState: State = {
  entities: [],
};

const prefix = "data/notebooks";

export const loadNotebooks = createAsyncThunk(
  `${prefix}/load-notebooks`,
  async (_, thunkAPI) => {
    return api(thunkAPI).get({
      url: "/drivers-api/notebooks",
      decoder: createDecoder(driverNotebooksT),
    });
  }
);

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadNotebooks.fulfilled, (state, action) => {
      state.entities = action.payload;
    });
  },
});

export default slice.reducer;
